import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { finalize } from 'rxjs/operators';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  resetPasswordForm: FormGroup;

  isLoading = false;

  constructor(
    public router: Router, // para manejar las rutas
    private formBuilder: FormBuilder, // para manejar los formularios
    private authenticationService: AuthenticationService // para el servicio
  ) {
    this.createForm();
  }

  ngOnInit() {}

  login() {
    this.isLoading = true;

    this.authenticationService
      .login(this.loginForm.value)
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe(
        (credentials: Authentication.Credentials) => {
          // console.log(credentials);

          //  this.router.navigate(['/dashboard']);
          this.router.navigate(['/dashboard']).then(() => {
            window.location.reload();
          });
        },
        (error: any) => {
          Swal.fire(`Login error: ${error.error}`);
          //  console.log(`Login error: ${error}`);
        }
      );
  }

  resetPassword() {
    // TODO: Implement Reset Password
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', Validators.required]
    });
  }
}
